import { css } from '@emotion/react'
import common from 'shared/styles'
import custom from 'shared/styles/custom.styles'

const styles = () => {
    return {
        main: css`
            ${common.fullContainer};
            display: flex;
            flex-direction: column;
            padding-left: 30px;
        `,
        actions: css`
            align-self: flex-start;
            flex-grow: 2;
        `,
        title: css`
            font-weight: 600;
            padding-bottom: 15px;
        `,
        description: custom.messageText,
    }
}

export default styles
